// extracted by mini-css-extract-plugin
export default {"shadow":"Card_shadow__H9-av","card":"Card_card__oHhc5","desc":"Card_desc__bB4Yo","logo":"Card_logo__V9exU"};